import React, { useState } from 'react';
import '../../../assets/css/Allfilter.css';
import {Link} from 'react-router-dom';

const AllFilter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <div className='ml-2'>
      <button className="primary bg-transparent text-black btn-button" onClick={handleOpen}>
        All Filter <i className="bi bi-funnel"></i>
      </button>
      <div className={`modal-overlay ${isOpen ? 'show' : ''}`} onClick={handleClose}></div>
      <div className={`slide-modal ${isOpen ? 'open' : ''}`}>
        <div className="modal-content">
          <button className="close-btn" onClick={handleClose}>×</button>
          <h2 className='text-lg' > Filter Results </h2>
          <fieldset className="border border-gray-300 border-solid p-1 rounded-md">
       <legend className="text-sm font-semibold text-gray-700 filtersolid">Price</legend>
  <ul className="space-y-2 mt-2 pl-0 m-3">
    <li className="border border-gray-300 p-2 rounded-md">
      <Link to="/" className="text-sm text-gray-600 hover:text-gray-800 flex items-center text-decoration-none" >
        Under - <i className="fa fa-inr mx-1" /> 5000
      </Link>
    </li>
    <li className="border border-gray-300 p-2 rounded-md">
      <Link to="/"
        className="text-sm text-gray-600 hover:text-gray-800 flex items-center text-decoration-none" >
        <i className="fa fa-inr mx-1" /> 5000 - <i className="fa fa-inr mx-1" /> 10000
      </Link>
    </li>
    <li className="border border-gray-300 p-2 rounded-md">
      <Link to="/" className="text-sm text-gray-600 hover:text-gray-800 flex items-center text-decoration-none" >
        <i className="fa fa-inr mx-1" /> 10000 - <i className="fa fa-inr mx-1" /> 20000
      </Link>
    </li>
    <li className="border border-gray-300 p-2 rounded-md">
      <Link  to="/"
        className="text-sm text-gray-600 hover:text-gray-800 flex items-center text-decoration-none" >
        <i className="fa fa-inr mx-1" /> 20000 - <i className="fa fa-inr mx-1" /> 50000
      </Link>
    </li>
    <li className="border border-gray-300 p-2 rounded-md">
      <Link to="#" className="text-sm text-gray-600 hover:text-gray-800 flex items-center text-decoration-none" >
        <i className="fa fa-inr mx-1" /> 50000 - Above
      </Link>
    </li>
  </ul>
</fieldset>
        </div>
      </div>
    </div>
  );
};
export default AllFilter;
